import { generateArraySchema, generateBooleanSchema, generateColorSchema, generateObjectSchema, generateRootObjectSchema, generateStringSchema, generateUrlSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { TextParticleSpec, RadioButtonParticleSpec } from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec("Radio Button", generateRootObjectSchema({
    container: generateAtomContainerSchema(),
    radio: RadioButtonParticleSpec.generateSchema("Radio Button", "The radio button."),
}));
